import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap',
    tabs: 'mb-2 w-full sm:border-y',
    tab: 'h-10 cursor-pointer px-10.75 py-2 whitespace-nowrap normal-case transition-colors',
    tabsWrap: 'flex cursor-grab max-sm:border-y',
    additionalTab:
      'heading-m text-tertiary hover:text-primary hover:border-primary border-tertiary min-w-44 shrink-0 grow cursor-pointer border-b p-3 whitespace-nowrap transition-colors',
    header: 'bg-base flex cursor-pointer px-5 py-4 normal-case select-none',
    headerIcon: 'ml-auto',
    wrapper: '',
    content: 'w-full',
    tabHeaderIcon: ''
  },
  variants: {
    color: {
      primary: 'text-primary'
    },
    view: {
      tab: {
        header: 'hidden',
        wrapper: 'order-2 max-h-max!',
        tabs: ''
      },
      additionalTab: {
        header: 'hidden',
        tabs: 'bg-base gap-4',
        wrapper: 'order-2 max-h-max!'
      },
      accordion: {
        tabs: 'hidden',
        header: 'mb-5 w-full',
        content: 'pb-5'
      },
      auto: {
        tabs: 'hidden md:flex',
        header: 'w-full max-md:mb-1 md:hidden',
        content: 'max-md:pb-5',
        wrapper: 'md:order-2 md:max-h-max!'
      },
      segmentedTab: {
        header: 'hidden',
        tabs: 'bg-base gap-4 border-none',
        tabsWrap: 'cursor-default gap-4 border-none',
        wrapper: 'order-2 max-h-max!',
        tab: 'heading-m px-1'
      }
    },
    active: {
      true: {
        tabHeaderIcon: 'brightness-0 invert filter'
      },
      false: {}
    }
  },
  compoundVariants: [
    {
      view: 'tab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: true,
      className: {
        additionalTab: 'border-primary heading-m-regular text-primary border-b-2'
      }
    },
    {
      view: 'auto',
      active: false,
      className: {
        content: 'md:hidden'
      }
    },
    {
      view: 'tab',
      active: true,
      className: {
        tab: 'bg-primary text-base'
      }
    },
    {
      view: 'tab',
      active: false,
      className: {
        tab: 'hover:bg-surface'
      }
    },
    {
      view: 'segmentedTab',
      active: false,
      className: {
        tab: 'hover:text-tertiary',
        content: 'hidden'
      }
    },
    {
      view: 'segmentedTab',
      active: true,
      className: {
        tab: 'border-primary heading-m-regular text-primary border-b-2'
      }
    }
  ],
  defaultVariants: {
    color: 'primary'
  }
});
